module.exports = __webpack_public_path__ + "media/hokej.305e937f.mp4";